/* assets/hdt-product-shipping-calc.js */
(() => {
  if (window.customElements.get('hdt-shipping-calc')) return;

  const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  // Seletor de TODOS os botões "Adicionar ao carrinho" da página.
  // Usado pelo lock visual durante o cálculo de frete no PDP.
  const ATC_SELECTOR = 'form[action*="/cart/add"] button[name="add"], product-form button[name="add"], hdt-buy-buttons button[type="submit"]';

  class HdtShippingCalc extends HTMLElement {
    constructor() {
      super();
      this.onSubmit = this.handleSubmit.bind(this);
      this.onInput  = this.maskCep.bind(this);
      this.onToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.form       = this.querySelector('.hdt-shipping-calc__form');
      this.input      = this.querySelector('.hdt-shipping-calc__input');
      this.button     = this.querySelector('.hdt-shipping-calc__button');
      this.feedbackEl = this.querySelector('.hdt-shipping-calc__feedback');
      this.loadingEl  = this.querySelector('.hdt-shipping-calc__loading');
      this.errorEl    = this.querySelector('.hdt-shipping-calc__error');
      this.ratesEl    = this.querySelector('.hdt-shipping-calc__rates');
      this.toggleBtn  = this.querySelector('[data-shipping-toggle]');

      this.context = this.dataset.context || 'product';
      this.messages = {
        invalid:    this.dataset.invalidMsg   || 'Informe um CEP válido (8 dígitos).',
        noRates:    this.dataset.noRatesMsg   || 'Nenhuma opção de frete disponível para este CEP.',
        emptyCart:  this.dataset.emptyCartMsg || 'Adicione produtos ao carrinho antes de calcular o frete.',
        error:      this.dataset.errorMsg     || 'Não foi possível calcular o frete agora. Tente novamente em instantes.',
        rateLimit:  this.dataset.rateLimitMsg || 'Muitos cálculos em sequência. Aguarde alguns segundos e tente novamente.',
        themeEditor:'O cálculo de frete só funciona na loja publicada. Abra a loja em uma nova aba para testar.',
      };
      this.labels = {
        open:  this.dataset.openLabel  || 'Calcule seu frete',
        close: this.dataset.closeLabel || 'Fechar',
      };

      this.form?.addEventListener('submit', this.onSubmit);
      this.input?.addEventListener('input', this.onInput);
      this.toggleBtn?.addEventListener('click', this.onToggle);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.input?.removeEventListener('input', this.onInput);
      this.toggleBtn?.removeEventListener('click', this.onToggle);
    }

    handleToggle() {
      const expanded = this.classList.toggle('is-expanded');
      if (this.toggleBtn) this.toggleBtn.textContent = expanded ? this.labels.close : this.labels.open;
      if (expanded) setTimeout(() => this.input?.focus(), 50);
    }

    maskCep(e) {
      const raw = e.target.value.replace(/\D/g, '').slice(0, 8);
      e.target.value = raw.length > 5 ? `${raw.slice(0, 5)}-${raw.slice(5)}` : raw;
    }

    setError(msg) {
      if (!this.errorEl || !this.feedbackEl) return;
      if (msg) {
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
        this.feedbackEl.hidden = false;
      } else {
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
        this.feedbackEl.hidden = this.loadingEl?.hidden !== false;
      }
    }

    setLoading(loading) {
      if (this.loadingEl) this.loadingEl.hidden = !loading;
      if (this.feedbackEl) this.feedbackEl.hidden = !loading && (this.errorEl?.hidden !== false);
      if (this.button) this.button.disabled = loading;
    }

    // === Cookie helpers ===
    // Lê o valor atual do cookie `cart` do Shopify. Token de cart do visitante.
    getCartCookie() {
      const parts = ('; ' + document.cookie).split('; cart=');
      return parts.length === 2 ? parts.pop().split(';').shift() : '';
    }

    // Sobrescreve o cookie `cart`. Quando setamos um valor desconhecido, o Shopify
    // cria silenciosamente um cart paralelo vazio associado a esse token.
    setCartCookie(value) {
      const d = new Date();
      d.setTime(d.getTime() + 14 * 864e5); // 14 dias
      document.cookie = 'cart=' + value + '; expires=' + d.toGMTString() + '; path=/';
    }

    // === ATC lock visual (sutil, não cinza opressivo) ===
    // Bloqueia clicks no ATC durante o cookie-swap pra evitar que o item do user
    // vá pro cart fake. Diferente do disabled cinza, mantém o visual quase igual.
    showAtcLock() {
      this._lockedButtons = [];
      document.querySelectorAll(ATC_SELECTOR).forEach(btn => {
        if (btn.dataset.hdtShippingLocked === '1') return;
        btn.dataset.hdtShippingLocked = '1';
        btn.dataset.hdtPrevOpacity = btn.style.opacity || '';
        btn.dataset.hdtPrevPointer = btn.style.pointerEvents || '';
        btn.dataset.hdtPrevCursor  = btn.style.cursor || '';
        btn.dataset.hdtPrevTitle   = btn.getAttribute('title') || '';
        btn.style.opacity = '0.75';
        btn.style.pointerEvents = 'none';
        btn.style.cursor = 'wait';
        btn.setAttribute('title', 'Aguarde, calculando frete...');
        this._lockedButtons.push(btn);
      });
    }

    hideAtcLock() {
      (this._lockedButtons || []).forEach(btn => {
        if (btn.dataset.hdtShippingLocked !== '1') return;
        btn.style.opacity = btn.dataset.hdtPrevOpacity;
        btn.style.pointerEvents = btn.dataset.hdtPrevPointer;
        btn.style.cursor = btn.dataset.hdtPrevCursor;
        if (btn.dataset.hdtPrevTitle) {
          btn.setAttribute('title', btn.dataset.hdtPrevTitle);
        } else {
          btn.removeAttribute('title');
        }
        delete btn.dataset.hdtShippingLocked;
        delete btn.dataset.hdtPrevOpacity;
        delete btn.dataset.hdtPrevPointer;
        delete btn.dataset.hdtPrevCursor;
        delete btn.dataset.hdtPrevTitle;
      });
      this._lockedButtons = [];
    }

    getVariantId() {
      const productForm = document.querySelector('product-form form, form[action*="/cart/add"]');
      const input = productForm?.querySelector('input[name="id"]')
                 || document.querySelector('product-form input[name="id"]')
                 || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return input?.value || null;
    }

    getQuantity() {
      const qty = document.querySelector('product-form .quantity__input')
               || document.querySelector('.quantity__input')
               || document.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(qty?.value, 10) || 1);
    }

    async fetchUf(zip) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${zip}/json/`);
        const data = await res.json();
        if (data?.erro) return null;
        return data?.uf || null;
      } catch {
        return null;
      }
    }

    async pollRates(url, { tries = 15, delay = 450 } = {}) {
      for (let i = 0; i < tries; i++) {
        try {
          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          const data = await res.json().catch(() => null);
          if (res.status === 200 && Array.isArray(data?.shipping_rates)) {
            return data.shipping_rates;
          }
          if (data?.errors) return null;
        } catch {}
        if (i < tries - 1) await new Promise(r => setTimeout(r, delay));
      }
      return [];
    }

    async handleSubmit(e) {
      e.preventDefault();

      // Theme Editor da Shopify roda o tema em iframe sandboxed que limpa cookies
      // entre requests (Clear-Site-Data) e bloqueia Web Pixels. /cart/add retorna 422
      // nesse ambiente. Avisa explicitamente em vez de mostrar erro genérico.
      if (window.Shopify?.designMode) {
        this.setError(this.messages.themeEditor);
        this.ratesEl.hidden = true;
        return;
      }

      const zip = (this.input?.value || '').replace(/\D/g, '');
      if (zip.length !== 8) {
        this.setError(this.messages.invalid);
        this.ratesEl.hidden = true;
        return;
      }

      // Impede clicks duplos rápidos no Calcular enquanto um cálculo está em andamento.
      if (this._busy) return;
      this._busy = true;

      this.setError('');
      this.setLoading(true);
      this.ratesEl.hidden = true;
      this.ratesEl.innerHTML = '';

      try {
        if (this.context === 'cart') {
          await this.calcCartContext(zip);
        } else {
          await this.calcProductContext(zip);
        }
      } finally {
        this.setLoading(false);
        this._busy = false;
      }
    }

    async calcCartContext(zip) {
      const root = (window.Shopify?.routes?.root) || '/';
      try {
        const uf = await this.fetchUf(zip);
        if (!uf) {
          this.setError(this.messages.invalid);
          return;
        }
        // No contexto cart, calculamos sobre o cart REAL existente — sem cookie swap,
        // sem manipulação. Se cart vazio, mostra mensagem.
        const cartRes = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = cartRes.ok ? await cartRes.json() : null;
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
          this.setError(this.messages.emptyCart);
          return;
        }

        const prepRes = await fetch(`${root}cart/prepare_shipping_rates.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ shipping_address: { zip, country: 'Brazil', province: uf } }),
        });
        if (prepRes.status === 429) throw new Error('rate_limit');
        if (!prepRes.ok && prepRes.status !== 202) throw new Error('prepare_failed');

        const params = new URLSearchParams({
          'shipping_address[zip]': zip,
          'shipping_address[country]': 'Brazil',
          'shipping_address[province]': uf,
        });
        const rates = await this.pollRates(`${root}cart/async_shipping_rates.json?${params.toString()}`);
        if (rates === null) throw new Error('rates_error');
        if (!rates.length) {
          this.setError(this.messages.noRates);
          return;
        }

        rates.sort((a, b) => Number(a.price) - Number(b.price));
        this.renderRates(rates);
      } catch (err) {
        this.setError(err?.message === 'rate_limit' ? this.messages.rateLimit : this.messages.error);
      }
    }

    // === Cálculo de frete no PDP via COOKIE SWAP ===
    // Approach inspirado na CUFF (cuff.com.br) e validado empiricamente.
    // Ao invés de modificar o cart real do user (snapshot/clear/restore — destrutivo
    // e quebra em browsers com cookie restriction), apenas trocamos o cookie `cart`
    // do browser por um token sintético. O Shopify abre um cart paralelo vazio
    // associado a esse token, que usamos como descartável pra cotar frete.
    // No final, restauramos o cookie. O cart real do user JAMAIS é tocado.
    async calcProductContext(zip) {
      const root = (window.Shopify?.routes?.root) || '/';
      const variantId = this.getVariantId();
      if (!variantId) {
        this.setError(this.messages.error);
        return;
      }
      const quantity = this.getQuantity();

      const uf = await this.fetchUf(zip);
      if (!uf) {
        this.setError(this.messages.invalid);
        return;
      }

      // Salva o cookie real do cart. Se o user nunca interagiu com o cart ainda
      // (cookie vazio), cria um temporário válido pra ter algo pra restaurar.
      let realCartCookie = this.getCartCookie();
      if (!realCartCookie) {
        this.setCartCookie('temp-cart-cookie___' + Date.now());
        realCartCookie = this.getCartCookie();
      }

      const fakeCartCookie = 'fake-cart-cookie___' + Date.now();

      // Watchdog: se algo prender (rede pendurada, aba inativa), restaura o cookie
      // automaticamente em 30s pra evitar que o user fique com cart fake permanente.
      const watchdog = setTimeout(() => {
        this.setCartCookie(realCartCookie);
        this.hideAtcLock();
      }, 30000);

      // Bloqueia visualmente o ATC durante o cálculo. Sem isso, o user pode clicar
      // ATC enquanto o cookie está trocado e o item vai pro cart fake (perdido).
      this.showAtcLock();

      // Troca cookie ANTES de qualquer request ao /cart/*.
      this.setCartCookie(fakeCartCookie);

      try {
        const addRes = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        if (addRes.status === 429) throw new Error('rate_limit');
        if (!addRes.ok) throw new Error('add_failed');

        const prepRes = await fetch(`${root}cart/prepare_shipping_rates.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ shipping_address: { zip, country: 'Brazil', province: uf } }),
        });
        if (prepRes.status === 429) throw new Error('rate_limit');
        if (!prepRes.ok && prepRes.status !== 202) throw new Error('prepare_failed');

        const params = new URLSearchParams({
          'shipping_address[zip]': zip,
          'shipping_address[country]': 'Brazil',
          'shipping_address[province]': uf,
        });
        const rates = await this.pollRates(`${root}cart/async_shipping_rates.json?${params.toString()}`);

        if (rates === null) throw new Error('rates_error');
        if (!rates.length) {
          this.setError(this.messages.noRates);
          return;
        }

        rates.sort((a, b) => Number(a.price) - Number(b.price));
        this.renderRates(rates);
      } catch (err) {
        this.setError(err?.message === 'rate_limit' ? this.messages.rateLimit : this.messages.error);
      } finally {
        // SEMPRE restaura o cookie real, mesmo se algo lançou exception no meio.
        // Esse é o ponto crítico do approach — sem isso, o user fica preso ao cart fake.
        this.setCartCookie(realCartCookie);
        clearTimeout(watchdog);
        this.hideAtcLock();
      }
    }

    formatEta(rate) {
      if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
        const last = Number(rate.delivery_days[rate.delivery_days.length - 1]);
        if (Number.isFinite(last) && last > 0) {
          return last === 1 ? 'Em até 1 dia útil' : `Em até ${last} dias úteis`;
        }
      }
      if (Array.isArray(rate.delivery_range) && rate.delivery_range.length) {
        const end = rate.delivery_range[rate.delivery_range.length - 1];
        if (end) {
          const endDate = new Date(end);
          const now = new Date();
          const diff = Math.ceil((endDate - now) / 86400000);
          if (Number.isFinite(diff) && diff > 0) {
            return diff === 1 ? 'Em até 1 dia útil' : `Em até ${diff} dias úteis`;
          }
        }
      }
      if (typeof rate.delivery_speed_text === 'string' && rate.delivery_speed_text.trim()) {
        return rate.delivery_speed_text;
      }
      return '';
    }

    formatPrice(price) {
      const num = Number(price);
      return Number.isFinite(num) ? BRL.format(num) : '';
    }

    escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }

    renderRates(rates) {
      this.ratesEl.innerHTML = rates.map(r => `
        <li class="hdt-shipping-calc__rate">
          <span class="hdt-shipping-calc__rate-name">${this.escapeHtml(r.presentment_name || r.name || '')}</span>
          <span class="hdt-shipping-calc__rate-eta">${this.escapeHtml(this.formatEta(r))}</span>
          <span class="hdt-shipping-calc__rate-price">${this.escapeHtml(this.formatPrice(r.price))}</span>
        </li>
      `).join('');
      this.ratesEl.hidden = false;
    }
  }

  customElements.define('hdt-shipping-calc', HdtShippingCalc);
})();
